import _classCallCheck from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Check/check';
import { css } from '@patternfly/react-styles';
import { getDefaultOUIAId, getOUIAProps } from '../../helpers'; // tslint:disable-next-line:no-empty

var defaultOnChange = function defaultOnChange() {};

export var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _this.handleChange = function (event) {
      _this.props.onChange(event.currentTarget.checked, event);
    };

    _this.state = {
      ouiaStateId: getDefaultOUIAId(Checkbox.displayName)
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          ariaLabel = _a['aria-label'],
          className = _a.className,
          onChange = _a.onChange,
          isValid = _a.isValid,
          isDisabled = _a.isDisabled,
          isChecked = _a.isChecked,
          label = _a.label,
          checked = _a.checked,
          defaultChecked = _a.defaultChecked,
          description = _a.description,
          body = _a.body,
          ouiaId = _a.ouiaId,
          ouiaSafe = _a.ouiaSafe,
          props = __rest(_a, ['aria-label', "className", "onChange", "isValid", "isDisabled", "isChecked", "label", "checked", "defaultChecked", "description", "body", "ouiaId", "ouiaSafe"]);

      if (!props.id) {
        // eslint-disable-next-line no-console
        console.error('Checkbox:', 'id is required to make input accessible');
      }

      var checkedProps = {};

      if ([true, false].includes(checked) || isChecked === true) {
        checkedProps.checked = checked || isChecked;
      }

      if (onChange !== defaultOnChange) {
        checkedProps.checked = isChecked;
      }

      if ([false, true].includes(defaultChecked)) {
        checkedProps.defaultChecked = defaultChecked;
      }

      checkedProps.checked = checkedProps.checked === null ? false : checkedProps.checked;
      return React.createElement("div", {
        className: css(styles.check, !label && styles.modifiers.standalone, className)
      }, React.createElement("input", Object.assign({}, props, {
        className: css(styles.checkInput),
        type: "checkbox",
        onChange: this.handleChange,
        "aria-invalid": !isValid,
        "aria-label": ariaLabel,
        disabled: isDisabled,
        ref: function ref(elem) {
          return elem && (elem.indeterminate = isChecked === null);
        }
      }, checkedProps, getOUIAProps(Checkbox.displayName, ouiaId !== undefined ? ouiaId : this.state.ouiaStateId, ouiaSafe))), label && React.createElement("label", {
        className: css(styles.checkLabel, isDisabled && styles.modifiers.disabled),
        htmlFor: props.id
      }, label), description && React.createElement("span", {
        className: css(styles.checkDescription)
      }, description), body && React.createElement("span", {
        className: css(styles.checkBody)
      }, body));
    }
  }]);

  return Checkbox;
}(React.Component);
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  className: '',
  isValid: true,
  isDisabled: false,
  isChecked: false,
  onChange: defaultOnChange,
  ouiaSafe: true
};